namespace Matrix.Dashboards {
    export interface DatasetListParametersResponse extends Serenity.ServiceResponse {
        Parameters?: Serenity.PropertyItem[];
    }
}
